/* Herb Terra shoppable video row plus lightbox. Rebuilt 17-09-2026.
 *
 * RAIL
 *   swipe or drag, arrows only where there is a real pointer
 *   press play to watch a clip in place, with sound unless the visitor turned it off
 *   sound toggle on the card while it plays, expand button to go full screen
 *   press the card or the expand button to open the lightbox at the same moment
 *
 * LIGHTBOX, deliberately different per device
 *   desktop  clip left, product panel right with price, title, gallery,
 *            variant choices, More info and Add to cart. Arrows either side.
 *   mobile   clip fills the screen, product bar pinned to the bottom with one
 *            Shop button. The clip follows the finger and snaps to the next or
 *            previous one, with up and down buttons and a counter as the
 *            non-gesture alternative, and a coach mark until the first swipe.
 *   both     the phone back gesture closes the lightbox instead of leaving
 *
 * Product data is fetched from /products/<handle>.js on open and cached.
 * Vanilla, defer loaded.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData === true;
  var MOBILE = '(max-width: 860px)';

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  function store(kind, key, value) {
    try {
      if (value === undefined) return window[kind].getItem(key);
      window[kind].setItem(key, value);
    } catch (e) { return null; }
  }

  // A tap on play is a request to watch, so sound starts on until the visitor turns it off.
  function soundWanted() { return store('sessionStorage', 'htcSvSound') !== '0'; }
  function rememberSound(on) { store('sessionStorage', 'htcSvSound', on ? '1' : '0'); }

  function playSafely(v, onBlocked) {
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        if (v.muted) return;
        v.muted = true;
        if (onBlocked) onBlocked();
        var p2 = v.play();
        if (p2 && typeof p2.catch === 'function') p2.catch(function () {});
      });
    }
  }

  function money(cents) {
    try {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) {}
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return (cur ? cur + ' ' : '$') + (cents / 100).toFixed(2);
  }

  function initSection(root) {
    var rail = root.querySelector('[data-htc-sv-rail]');
    if (!rail) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-htc-sv-slide]'));
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced && !saveData;
    var hintText = root.getAttribute('data-hint') || '';
    var cache = {};

    /* ================= rail ================= */

    function videoOf(slide) { return slide.querySelector('[data-htc-sv-video]'); }

    function load(video) {
      if (!video || video.dataset.loaded === '1') return;
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.dataset.loaded = '1';
      var s = document.createElement('source');
      s.setAttribute('src', src);
      s.setAttribute('type', src.indexOf('.webm') > -1 ? 'video/webm' : 'video/mp4');
      video.appendChild(s);
      video.load();
    }

    function mark(slide, playing) {
      slide.setAttribute('data-playing', playing ? 'true' : 'false');
      var snd = slide.querySelector('[data-htc-sv-sound]');
      var v = videoOf(slide);
      if (snd) snd.hidden = !playing && !(v && v.currentTime > 0);
    }

    function syncSound(slide) {
      var v = videoOf(slide);
      var snd = slide.querySelector('[data-htc-sv-sound]');
      if (!v || !snd) return;
      snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
    }

    function stopRail(except) {
      slides.forEach(function (s) {
        if (s === except) return;
        var v = videoOf(s);
        if (v && !v.paused) v.pause();
        mark(s, false);
      });
    }

    slides.forEach(function (slide) {
      var btn = slide.querySelector('[data-htc-sv-play]');
      var v = videoOf(slide);
      mark(slide, false);
      if (!btn || !v) return;

      var playLabel = btn.getAttribute('aria-label') || '';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (v.paused) {
          stopRail(slide);
          load(v);
          v.muted = !soundWanted();
          syncSound(slide);
          playSafely(v, function () { syncSound(slide); });
        } else {
          v.pause();
        }
      });

      var snd = slide.querySelector('[data-htc-sv-sound]');
      if (snd) {
        snd.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          v.muted = !v.muted;
          rememberSound(!v.muted);
          syncSound(slide);
          if (v.paused) playSafely(v, function () { syncSound(slide); });
        });
      }

      var expand = slide.querySelector('[data-htc-sv-expand]');
      if (expand) {
        expand.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          lb.open(slides.indexOf(slide), v.currentTime, expand);
        });
      }

      v.addEventListener('play', function () {
        mark(slide, true);
        btn.setAttribute('aria-label', playLabel.replace(/^Play/, 'Pause'));
      });
      v.addEventListener('pause', function () {
        mark(slide, false);
        btn.setAttribute('aria-label', playLabel);
      });
      v.addEventListener('volumechange', function () { syncSound(slide); });

      var open = slide.querySelector('[data-htc-sv-open]');
      if (open) {
        open.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          lb.open(slides.indexOf(slide), v.currentTime, open);
        });
      }
    });

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          load(videoOf(e.target));
          near.unobserve(e.target);
        });
      }, { rootMargin: '400px' });

      var onScreen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = videoOf(e.target);
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio > 0.55) {
            if (autoplay && v.paused) {
              load(v);
              v.muted = true;
              var p = v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.55, 1] });

      slides.forEach(function (s) { near.observe(s); onScreen.observe(s); });
    } else {
      slides.forEach(function (s) { load(videoOf(s)); });
    }

    var prev = root.querySelector('[data-htc-sv-prev]');
    var next = root.querySelector('[data-htc-sv-next]');

    function step() {
      if (!slides[0]) return rail.clientWidth * 0.8;
      var cs = getComputedStyle(rail);
      var gap = parseInt(cs.columnGap || cs.gap || '20', 10) || 20;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function syncArrows() {
      if (!prev || !next) return;
      if (rail.scrollWidth - rail.clientWidth <= 4) {
        prev.hidden = true; next.hidden = true; return;
      }
      prev.hidden = rail.scrollLeft <= 4;
      next.hidden = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });

    var st; rail.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(syncArrows, 90); }, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(syncArrows, 150); });
    syncArrows();
    if ('ResizeObserver' in window) new ResizeObserver(syncArrows).observe(rail);

    /* ================= lightbox ================= */

    var lb = (function () {
      var el = root.querySelector('[data-htc-lb]');
      if (!el) return { open: function () {} };

      var q = function (n) { return el.querySelector('[data-htc-lb-' + n + ']'); };
      var video = q('video');
      var progress = q('progress');
      var handleEl = q('handle');
      var soundBtn = q('sound');
      var navPrev = q('prev');
      var navNext = q('next');
      var closeBtn = q('close');
      var peekPrev = q('peek-prev');
      var peekNext = q('peek-next');
      var priceEl = q('price');
      var titleEl = q('title');
      var gimg = q('gimg');
      var gprev = q('gprev');
      var gnext = q('gnext');
      var dots = q('dots');
      var optsEl = q('opts');
      var moreEl = q('more');
      var atcEl = q('atc');
      var mLink = q('mbar-link');
      var mImg = q('mbar-img');
      var mPrice = q('mbar-price');
      var mTitle = q('mbar-title');
      var mCta = q('mbar-cta');
      var hintEl = q('hint');
      var coach = q('coach');
      var countEl = q('count');
      var upBtn = q('up');
      var downBtn = q('down');
      var stateEl = q('state');
      var screen = q('screen');
      var pushed = false;
      var moving = false;
      var suppressTap = false;
      var closing = false;

      var idx = -1;
      var product = null;
      var variant = null;
      var chosen = {};
      var images = [];
      var imgIdx = 0;
      var lastFocus = null;
      var scrollY = 0;

      function srcOf(i) { return slides[i] ? slides[i].getAttribute('data-src') : ''; }

      function setPeek(node, i) {
        var wrap = node && node.parentElement;
        if (!wrap) return;
        var s = srcOf(i);
        if (!s) { wrap.classList.add('is-empty'); node.removeAttribute('src'); return; }
        wrap.classList.remove('is-empty');
        // The fragment makes iOS paint the first frame without playing.
        if (node.getAttribute('src') !== s + '#t=0.1') node.setAttribute('src', s + '#t=0.1');
      }

      function renderGallery() {
        if (!images.length) { gimg.removeAttribute('src'); dots.innerHTML = ''; gprev.hidden = true; gnext.hidden = true; return; }
        imgIdx = Math.max(0, Math.min(imgIdx, images.length - 1));
        gimg.src = images[imgIdx];
        gimg.alt = product ? product.title : '';
        var many = images.length > 1;
        gprev.hidden = !many;
        gnext.hidden = !many;
        dots.innerHTML = '';
        if (many) {
          images.forEach(function (_, i) {
            var d = document.createElement('i');
            if (i === imgIdx) d.className = 'is-on';
            dots.appendChild(d);
          });
        }
      }

      function matchVariant() {
        if (!product) return null;
        var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        var want = names.map(function (n) { return chosen[n]; });
        var found = null;
        product.variants.forEach(function (v) {
          if (found) return;
          var ok = true;
          want.forEach(function (val, i) { if (val && v.options[i] !== val) ok = false; });
          if (ok) found = v;
        });
        return found || product.variants[0];
      }

      function renderPrice() {
        if (!product) return;
        var v = variant;
        var html = '';
        if (v) {
          if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s>';
          html += money(v.price);
        }
        priceEl.innerHTML = html;

        var lo = product.price_min, hi = product.price_max;
        mPrice.textContent = (lo !== hi) ? (money(lo) + ' to ' + money(hi)) : money(lo);

        atcEl.disabled = !(v && v.available);
        atcEl.textContent = (v && v.available) ? atcEl.dataset.label : 'Sold out';
      }

      function renderOptions() {
        optsEl.innerHTML = '';
        if (!product) return;
        var opts = product.options || [];
        var only = opts.length === 1 && (opts[0].name || opts[0]) === 'Title';
        if (only) return;

        opts.forEach(function (o, oi) {
          var name = typeof o === 'string' ? o : o.name;
          var values = (typeof o === 'string')
            ? product.variants.map(function (v) { return v.options[oi]; }).filter(function (v, i, a) { return a.indexOf(v) === i; })
            : o.values;

          var wrap = document.createElement('div');
          wrap.className = 'htc-lb__opt';
          var h = document.createElement('p');
          h.className = 'htc-lb__opt-name';
          h.textContent = name;
          wrap.appendChild(h);

          var row = document.createElement('div');
          row.className = 'htc-lb__opt-vals';

          values.forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'htc-lb__swatch';
            b.textContent = val;
            b.setAttribute('aria-pressed', chosen[name] === val ? 'true' : 'false');
            var any = product.variants.some(function (v) { return v.options[oi] === val && v.available; });
            if (!any) b.disabled = true;
            b.addEventListener('click', function () {
              chosen[name] = val;
              variant = matchVariant();
              if (variant && variant.featured_image && variant.featured_image.src) {
                var i = images.indexOf(variant.featured_image.src);
                if (i > -1) imgIdx = i;
              }
              renderOptions(); renderPrice(); renderGallery();
            });
            row.appendChild(b);
          });

          wrap.appendChild(row);
          optsEl.appendChild(wrap);
        });
      }

      function applyProduct(p, slide) {
        product = p;
        chosen = {};
        images = (p.images || []).slice(0, 8);
        imgIdx = 0;

        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        (p.options || []).forEach(function (o, i) {
          var name = typeof o === 'string' ? o : o.name;
          chosen[name] = first.options[i];
        });
        variant = first;

        var url = slide.getAttribute('data-url') || ('/products/' + p.handle);
        titleEl.textContent = p.title;
        mTitle.textContent = p.title;
        moreEl.href = url;
        mLink.href = url;
        mCta.href = url;
        mCta.textContent = slide.getAttribute('data-cta') || 'Shop now';
        if (images[0]) { mImg.src = images[0]; mImg.alt = ''; }

        renderOptions(); renderPrice(); renderGallery();
      }

      function fetchProduct(slide, quietly) {
        var h = slide && slide.getAttribute('data-product');
        if (!h) return;
        if (cache[h]) { if (!quietly) applyProduct(cache[h], slide); return; }
        fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p) { cache[h] = p; if (idx > -1 && slides[idx] === slide) applyProduct(p, slide); } })
          .catch(function () {});
      }

      function syncLbSound() {
        soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        soundBtn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
      }

      function show(i, startAt) {
        if (i < 0 || i >= slides.length) return;
        idx = i;
        var slide = slides[i];

        var s = slide.getAttribute('data-src');
        video.pause();
        video.removeAttribute('src');
        while (video.firstChild) video.removeChild(video.firstChild);
        if (s) { video.src = s; video.load(); }
        if (startAt > 0.3) {
          video.addEventListener('loadedmetadata', function seek() {
            video.removeEventListener('loadedmetadata', seek);
            if (startAt < video.duration - 0.5) video.currentTime = startAt;
          });
        }
        video.muted = !soundWanted();
        syncLbSound();
        stateEl.classList.remove('is-on');
        progress.style.width = '0%';
        countEl.textContent = (i + 1) + ' / ' + slides.length;
        upBtn.disabled = i <= 0;
        downBtn.disabled = i >= slides.length - 1;

        handleEl.textContent = slide.getAttribute('data-handle') || '';

        priceEl.innerHTML = '';
        titleEl.textContent = '';
        optsEl.innerHTML = '';
        mTitle.textContent = '';
        mPrice.textContent = '';
        mImg.removeAttribute('src');
        fetchProduct(slide);
        // Load the neighbours' product details now so a swipe shows them at once.
        fetchProduct(slides[i + 1], true);
        fetchProduct(slides[i - 1], true);

        video.style.opacity = moving ? '0' : '';
        if (!moving) {
          setPeek(peekPrev, i - 1);
          setPeek(peekNext, i + 1);
        }
        navPrev.disabled = i <= 0;
        navNext.disabled = i >= slides.length - 1;

        playSafely(video, syncLbSound);
      }

      function slideTo(node, transform, animate) {
        if (!node) return;
        node.style.transition = animate && !reduced ? 'transform 0.22s ease-out' : 'none';
        node.style.transform = transform;
      }
      function resetPeeks(animate) {
        slideTo(peekPrev.parentElement, '', animate);
        slideTo(peekNext.parentElement, '', animate);
      }

      /* The clip slides away and the neighbour that was following the finger takes
         its place. The new clip stays transparent until its first frame is ready,
         so the neighbour's frame shows through and there is no black flash. */
      function go(i, dir) {
        if (i < 0 || i >= slides.length || i === idx || moving) {
          slideTo(screen, '', true);
          resetPeeks(true);
          return;
        }
        if (reduced || !isMobile()) { resetPeeks(false); slideTo(screen, '', false); show(i); return; }
        moving = true;
        var peek = (dir > 0 ? peekNext : peekPrev).parentElement;
        slideTo(screen, 'translateY(' + (dir > 0 ? -100 : 100) + '%)', true);
        slideTo(peek, 'translateY(0)', true);
        setTimeout(function () {
          show(i);
          slideTo(screen, '', false);
          var done = false;
          function reveal() {
            if (done) return;
            done = true;
            video.removeEventListener('loadeddata', reveal);
            video.style.opacity = '';
            resetPeeks(false);
            setPeek(peekPrev, idx - 1);
            setPeek(peekNext, idx + 1);
            moving = false;
          }
          video.addEventListener('loadeddata', reveal);
          setTimeout(reveal, 1200);
        }, 220);
      }
      function next() { go(idx + 1, 1); }
      function prev() { go(idx - 1, -1); }

      function lockScroll(on) {
        if (on) {
          scrollY = window.scrollY || window.pageYOffset;
          document.body.style.position = 'fixed';
          document.body.style.top = -scrollY + 'px';
          document.body.style.width = '100%';
        } else {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          window.scrollTo(0, scrollY);
        }
      }

      var coachTimer = null;
      function hideCoach() {
        clearTimeout(coachTimer);
        if (coach.hidden) return;
        coach.classList.remove('is-on');
        setTimeout(function () { coach.hidden = true; }, 250);
      }
      function showHint() {
        if (!hintText || !isMobile() || slides.length < 2) return;
        if (store('localStorage', 'htcSvSwiped') === '1') return;
        var seen = parseInt(store('localStorage', 'htcSvCoach') || '0', 10) || 0;
        if (seen >= 3) return;
        store('localStorage', 'htcSvCoach', String(seen + 1));
        hintEl.textContent = hintText;
        coach.hidden = false;
        requestAnimationFrame(function () { coach.classList.add('is-on'); });
        coachTimer = setTimeout(hideCoach, 4000);
      }

      function open(i, startAt, trigger) {
        stopRail(null);
        lastFocus = trigger || document.activeElement;
        atcEl.dataset.label = atcEl.textContent.trim();
        el.hidden = false;
        lockScroll(true);
        requestAnimationFrame(function () { el.classList.add('is-open'); });
        moving = false;
        slideTo(screen, '', false);
        resetPeeks(false);
        show(i, startAt);
        showHint();
        closeBtn.focus({ preventScroll: true });
        try { history.pushState({ htcLb: true }, ''); pushed = true; } catch (e) { pushed = false; }
      }

      function close(fromHistory) {
        if (el.hidden || closing) return;
        closing = true;
        el.classList.remove('is-open');
        video.pause();
        hideCoach();
        if (pushed && fromHistory !== true) history.back();
        pushed = false;
        setTimeout(function () {
          el.hidden = true;
          closing = false;
          video.removeAttribute('src');
          lockScroll(false);
          if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
        }, 200);
      }

      window.addEventListener('popstate', function () { if (!el.hidden) close(true); });

      /* controls */
      closeBtn.addEventListener('click', close);
      navPrev.addEventListener('click', function () { show(idx - 1); });
      navNext.addEventListener('click', function () { show(idx + 1); });
      upBtn.addEventListener('click', function () { hideCoach(); prev(); });
      downBtn.addEventListener('click', function () { hideCoach(); next(); });
      coach.addEventListener('click', hideCoach);

      // Tap the clip to pause or resume, as on TikTok.
      video.addEventListener('click', function () {
        if (suppressTap) { suppressTap = false; return; }
        if (video.paused) { playSafely(video, syncLbSound); stateEl.classList.remove('is-on'); }
        else { video.pause(); stateEl.classList.add('is-on'); }
      });

      el.addEventListener('click', function (e) {
        if (e.target === el || e.target === el.querySelector('[data-htc-lb-stage]')) close();
      });

      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        rememberSound(!video.muted);
        syncLbSound();
      });

      video.addEventListener('timeupdate', function () {
        if (!video.duration) return;
        progress.style.width = (video.currentTime / video.duration * 100) + '%';
      });

      video.addEventListener('ended', function () {
        if (idx < slides.length - 1) next(); else video.play();
      });

      gprev.addEventListener('click', function () { imgIdx = (imgIdx - 1 + images.length) % images.length; renderGallery(); });
      gnext.addEventListener('click', function () { imgIdx = (imgIdx + 1) % images.length; renderGallery(); });

      atcEl.addEventListener('click', function () {
        if (!variant || !variant.available) return;
        var label = atcEl.textContent;
        atcEl.disabled = true;
        atcEl.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function () {
            atcEl.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              close();
              setTimeout(function () { window.location.href = '/cart'; }, 220);
            }, 500);
          })
          .catch(function () {
            atcEl.disabled = false;
            atcEl.textContent = label;
            window.location.href = moreEl.href;
          });
      });

      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); show(idx + 1); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); show(idx - 1); }
        else if (e.key === 'Tab') {
          var f = Array.prototype.filter.call(el.querySelectorAll('button, a[href]'), function (n) {
            return !n.disabled && n.offsetParent !== null && getComputedStyle(n).visibility !== 'hidden';
          });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      /* Mobile: the clip follows the finger, then snaps to the next or previous one */
      var y0 = null, x0 = null, t0 = 0, dragging = false, dy = 0;

      function fromControl(target) {
        return target.closest && target.closest('button, a, [data-htc-lb-mbar]');
      }

      screen.addEventListener('touchstart', function (e) {
        if (!isMobile() || e.touches.length !== 1 || moving || fromControl(e.target)) { y0 = null; return; }
        hideCoach();
        y0 = e.touches[0].clientY;
        x0 = e.touches[0].clientX;
        t0 = Date.now();
        dragging = false;
        dy = 0;
      }, { passive: true });

      screen.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        var t = e.touches[0];
        dy = t.clientY - y0;
        var dx = t.clientX - x0;
        if (!dragging) {
          if (Math.abs(dy) < 10 || Math.abs(dx) > Math.abs(dy)) return;
          dragging = true;
          screen.style.transition = 'none';
        }
        var atEnd = (dy < 0 && idx >= slides.length - 1) || (dy > 0 && idx <= 0);
        screen.style.transform = 'translateY(' + (atEnd ? dy * 0.25 : dy) + 'px)';
        if (!atEnd) {
          slideTo(peekNext.parentElement, dy < 0 ? 'translateY(calc(100% + ' + dy + 'px))' : '', false);
          slideTo(peekPrev.parentElement, dy > 0 ? 'translateY(calc(-100% + ' + dy + 'px))' : '', false);
        }
      }, { passive: true });

      function endDrag() {
        if (y0 === null) return;
        y0 = null;
        if (!dragging) return;
        dragging = false;
        suppressTap = true;
        setTimeout(function () { suppressTap = false; }, 350);
        var speed = Math.abs(dy) / Math.max(1, Date.now() - t0);
        var far = Math.abs(dy) > screen.clientHeight * 0.18 || (Math.abs(dy) > 40 && speed > 0.5);
        if (far && dy < 0 && idx < slides.length - 1) { store('localStorage', 'htcSvSwiped', '1'); next(); }
        else if (far && dy > 0 && idx > 0) { store('localStorage', 'htcSvSwiped', '1'); prev(); }
        else go(idx, 0);
      }
      screen.addEventListener('touchend', endDrag, { passive: true });
      screen.addEventListener('touchcancel', endDrag, { passive: true });

      return { open: open };
    })();
  }

  function boot() {
    document.querySelectorAll('[data-htc-sv]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-htc-sv]');
    if (el) initSection(el);
  });
})();
